/**
 * These constants are to be kept in sync with corresponding SCSS Variebles
 * Needed for JS logic based on Style/UI constraints
 */
export const UI = {
    // Breakpoint Mobile -> Desktop
    // Keep in sync with _variables.scss::$mobile-max-size
    MOBILE_MAX_SIZE: 900,
};
